<mat-dialog-content >
   <form [formGroup]="pwdFrm"
         class="form-container">
      <mat-form-field class="w-full" appearance="fill">
         <mat-label>Password</mat-label>
         <input matInput [type]="hidepw ? 'password' : 'text'" formControlName="password" >
         <button mat-icon-button matSuffix tabindex="-1"
                 (click)="hidepw = !hidepw"
                 [attr.aria-label]="'Nascondi password'" [attr.aria-pressed]="hidepw">
            <mat-icon>{{hidepw ? 'visibility_off' : 'visibility'}}</mat-icon>
         </button>
         <mat-error *ngIf="pwdFrm.get('password')?.hasError('required')">
            La password è <strong>obbligatoria</strong>
         </mat-error>
         <mat-hint>La password deve contenere almeno 8 caratteri alfanumerici</mat-hint>
      </mat-form-field>

      <mat-form-field appearance="fill" class="w-full mt-3">
         <mat-label>Conferma la password</mat-label>
         <input matInput [type]="hidepw2 ? 'password' : 'text'"
                readonly onfocus="this.removeAttribute('readonly');"
                tabindex="2"
                formControlName="confirm_password" autocomplete="nope" >
         <button mat-icon-button matSuffix tabindex="-1"
                 (click)="hidepw2 = !hidepw2"
                 [attr.aria-label]="'Nascondi password'" [attr.aria-pressed]="hidepw2">
            <mat-icon>{{hidepw2 ? 'visibility_off' : 'visibility'}}</mat-icon>
         </button>
         <mat-error *ngIf="pwdFrm.get('confirm_password')?.hasError('required')">
            La password è <strong>obbligatoria</strong>
         </mat-error>
         <mat-error *ngIf="pwdFrm.hasError('not_same_pswd')">
            Le password non corrispondono
         </mat-error>
      </mat-form-field>
   </form>
</mat-dialog-content>
